import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'
// import { Toast } from 'vant'

Vue.use(Router)

const router = new Router({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			redirect: '/main/curriculum_index'
			// redirect : '/test'
			// redirect : '/login_main_account'
		},
		{
			path: '/main',
			name: 'Main',
			component: () => import('./views/main/Main.vue'),
			children: [{
					path: 'curriculum_index',
					name: 'CurriculumIndex',
					component: () => import('./views/curriculum/curriculum_index.vue'),
					meta: {
						keepAlive: true
					}
				},
				{
					path: 'practice_index',
					name: 'PracticeIndex',
					component: () => import('./views/practice/practice_index.vue'),
					meta: {
						keepAlive: true
					}
				},
				{
					path: 'profile_index',
					name: 'ProfileIndex',
					component: () => import('./views/profile/profile_index.vue'),
					meta: {
						keepAlive: true
					}
				},
				{
					path: 'book_index',
					name: 'Book_index',
					component: () => import('./views/books/book_index'),
					meta: {
						keepAlive: true
					}
				},
				{
					path: '/company',
					name: 'Company',
					component: () => import('./views/company/company.vue'),
					meta: {
						keepAlive: true
					}
				},				
			]
		},
		{
			path: '/login_main_account',
			name: 'LoginMainAccount',
			component: () => import('./views/login/login_main_account.vue')
		},
		{
			path: '/login_register',
			name: 'LoginRegister',
			component: () => import('./views/login/login_register.vue')
		},
		{
			path: '/login_forgot_password',
			name: 'LoginForgotPassword',
			component: () => import('./views/login/login_forgot_password.vue')
		},
		{
			path: '/skuCurriculum_list',
			name: 'SkuCurriculumList',
			component: () => import('./views/curriculum/skuCurriculum_list.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/curriculum_bind',
			name: 'CurriculumBind',
			component: () => import('./views/curriculum/curriculum_bind.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/skuCurriculum_detail',
			name: 'SkuCurriculumDetail',
			component: () => import('./views/curriculum/skuCurriculum_detail.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/skuCurriculum_cart',
			name: 'SkuCurriculumCart',
			component: () => import('./views/curriculum/skuCurriculum_cart.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/skuCurriculum_order_agreement',
			name: 'SkuCurriculumOrderAgreement',
			component: () => import('./views/curriculum/skuCurriculum_order_agreement.vue')
		},
		{
			path: '/curriculum_confirm_order',
			name: 'CurriculumConfirmOrder',
			component: () => import('./views/curriculum/curriculum_confirm_order.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/curriculum_confirm_order_group',
			name: 'CurriculumConfirmOrderGroup',
			component: () => import('./views/group_curriculum/curriculum_confirm_order_group.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/groupCurriculum_order_agreement',
			name: 'GroupCurriculumOrderAgreement',
			component: () => import('./views/group_curriculum/groupCurriculum_order_agreement.vue')
		},
		{
			path: '/address_list',
			name: 'AddressList',
			component: () => import('./views/address/address_list.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/address_edit',
			name: 'AddressEdit',
			component: () => import('./views/address/address_edit.vue')
		},
		{
			path: '/curriculum_search',
			name: 'CurriculumSearch',
			component: () => import('./views/curriculum/curriculum_search.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/pay_success',
			name: 'Pay_success',
			component: () => import('./views/curriculum/pay_success.vue')
		},
		{
			path: '/pay_fail',
			name: 'Pay_fail',
			component: () => import('./views/curriculum/pay_fail.vue')
		},
		{
			path: '/pay_result_h5',
			name: 'PayResultH5',
			component: () => import('./views/curriculum/pay_result_h5.vue')
		},
		{
			path: '/my_curriculum',
			name: 'My_curriculum',
			component: () => import('./views/profile/my_curriculum')
		},
		{
			path: '/my_curriculum_order',
			name: 'MyCurriculumOrder',
			component: () => import('./views/profile/my_curriculum_order')
		},
		{
			path: '/my_welfare_center_detail',
			name: 'MyInformationCollectionDetail',
			component: () => import('./views/profile/my_information_collection_detail')
		},
		{
			path: '/my_welfare_center_list',
			name: 'MyInformationCollectionList',
			component: () => import('./views/profile/my_information_collection_list')
		},
		{
			path: '/logistics_list',
			name: 'Logistics_list',
			component: () => import('./views/logistics/logistics_list')
		},
		{
			path: '/order_logistics',
			name: 'OrderLogistics',
			component: () => import('./views/books/order_logistics')
		},
		{
			path: '/logistics_detail',
			name: 'Logistics_detail',
			component: () => import('./views/logistics/logistics_detail')
		},
		{
			path: '/book_search',
			name: 'BookSearch',
			component: () => import('./views/books/book_search.vue')
		},
		{
			path: '/book_cart',
			name: 'BookCart',
			component: () => import('./views/books/book_cart.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/book_detail',
			name: 'BookDetail',
			component: () => import('./views/books/book_detail.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/book_confirm_order',
			name: 'BookConfirmOrder',
			component: () => import('./views/books/book_confirm_order.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/book_pay_success',
			name: 'Book_pay_success',
			component: () => import('./views/books/pay_success.vue')
		},
		{
			path: '/book_pay_fail',
			name: 'Book_pay_fail',
			component: () => import('./views/books/pay_fail.vue')
		},
		{
			path: '/book_pay_result_h5',
			name: 'Book_payResultH5',
			component: () => import('./views/books/pay_result_h5.vue')
		},
		{
			path: '/my_book_order',
			name: 'MyBookOrder',
			component: () => import('./views/profile/my_book_order.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/curriculum_study',
			name: 'CurriculumStudy',
			component: () => import('./views/curriculum/curriculum_study')
		},
		{
			path: '/bjy_playback',
			name: 'BjyPlayback',
			component: () => import('./views/bjy_playback/bjy_playback')
		},
        {
            path: '/playback',
            name: 'Playback',
            component: () => import('./views/bjy_playback/playback')
        },		
		{
			path: '/practice_collection',
			name: 'PracticeCollection',
			component: () => import('./views/practice/practice_collection.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_collection_detail',
			name: 'PracticeCollectionDetail',
			component: () => import('./views/practice/practice_collection_detail.vue')
		},
		{
			path: '/practice_wrong',
			name: 'PracticeWrong',
			component: () => import('./views/practice/practice_wrong.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_wrong_detail',
			name: 'PracticeWrongDetail',
			component: () => import('./views/practice/practice_wrong_detail')
		},
		{
			path: '/practice_chapter',
			name: 'PracticeChapter',
			component: () => import('./views/practice/practice_chapter'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_chapter_history',
			name: 'PracticeChapterHistory',
			component: () => import('./views/practice/practice_chapter_history'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_chapter_history_detail',
			name: 'PracticeChapterHistoryDetail',
			component: () => import('./views/practice/practice_chapter_history_detail')
		},
		{
			path: '/practice_chapter_history_redo',
			name: 'PracticeChapterHistoryRedo',
			component: () => import('./views/practice/practice_chapter_history_redo')
		},
		{
			path: '/practice_chapter_detail',
			name: 'PracticeChapterDetail',
			component: () => import('./views/practice/practice_chapter_detail')
		},
		{
			path: '/practice_chapter_result',
			name: 'PracticeChapterResult',
			component: () => import('./views/practice/practice_chapter_result')
		},
		{
			path: '/distribution_bill',
			name: 'DistributionBill',
			component: () => import('./views/profile/distribution_bill'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/living_curriculum',
			name: 'LivingCurriculum',
			component: () => import('./views/curriculum/living_curriculum'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/live',
			name: 'Live',
			component: () => import('./views/curriculum/live'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/history',
			name: 'History',
			component: () => import('./views/history/history'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/notice_list',
			name: 'Notice_list',
			component: () => import('./views/notice/notice_list'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/notice_detail',
			name: 'Notice_detail',
			component: () => import('./views/notice/notice_detail'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_year',
			name: 'PracticeYear',
			component: () => import('./views/practice/practice_year.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_year_detail',
			name: 'PracticeYearDetail',
			component: () => import('./views/practice/practice_year_detail.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_year_question_analysis',
			name: 'PracticeYearQuestionAnalysis',
			component: () => import('./views/practice/practice_year_question_analysis.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/practice_year_result',
			name: 'PracticeYearResult',
			component: () => import('./views/practice/practice_year_result.vue')
		},
		{
			path: '/practice_year_record',
			name: 'PracticeYearRecord',
			component: () => import('./views/practice/practice_year_record.vue')
		},
		{
			path: '/year_pay_result_h5',
			name: 'Year_payResultH5',
			component: () => import('./views/practice/pay_result_h5.vue')
		},
		{
			path: '/evaluation_list',
			name: 'EvaluationList',
			component: () => import('./views/evaluation/evaluation_list.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/evaluation_detail',
			name: 'EvaluationDetail',
			component: () => import('./views/evaluation/evaluation_detail.vue'),
		},
		{
			path: '/evaluation_result',
			name: 'EvaluationResult',
			component: () => import('./views/evaluation/evaluation_result.vue'),
		},
		{
			path: '/evaluation_record',
			name: 'EvaluationRecord',
			component: () => import('./views/evaluation/evaluation_record.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/record_detail',
			name: 'RecordDetail',
			component: () => import('./views/evaluation/record_detail.vue'),
		},
		{
			path: '/welfare_center',
			name: 'InformationCollection',
			component: () => import('./views/information_collection/information_collection'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/welfare_pay_result_h5',
			name: 'Welfare_payResultH5',
			component: () => import('./views/information_collection/pay_result_h5.vue')
		},
		{
			path: '/comment_todo',
			name: 'CommentTodo',
			component: () => import('./views/comment/comment_todo.vue'),
		},
		{
			path: '/comment_list',
			name: 'CommentList',
			component: () => import('./views/comment/comment_list.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/comment_detail',
			name: 'CommentDetail',
			component: () => import('./views/comment/comment_detail.vue')
		},
		{
			path: '/afterSale_application',
			name: 'AfterSaleApplication',
			component: () => import('./views/after_sale/afterSale_application.vue')
		},
		{
			path: '/refund_list',
			name: 'RefundList',
			component: () => import('./views/after_sale/refund_list.vue')
		},
		{
			path: '/refund_detail',
			name: 'Refund_detail',
			component: () => import('./views/after_sale/refund_detail')
		},
		{
			path: '/curriculum_refund_detail',
			name: 'CurriculumRefund_detail',
			component: () => import('./views/after_sale/curriculum_refund_detail')
		},
		{
			path: '/sendBack_express',
			name: 'SendBackExpress',
			component: () => import('./views/after_sale/sendBack_express.vue')
		},
		{
			path: '/face_list',
			name: 'FaceList',
			component: () => import('./views/face_curriculum/face_list.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/face_detail',
			name: 'FaceDetail',
			component: () => import('./views/face_curriculum/face_detail.vue')
		},
		{
			path: '/face_confirm_order',
			name: 'FaceConfirmOrder',
			component: () => import('./views/face_curriculum/face_confirm_order.vue')
		},
		{
			path: '/pay_face_success',
			name: 'Pay_face_success',
			component: () => import('./views/face_curriculum/pay_face_success.vue')
		},
		{
			path: '/pay_face_fail',
			name: 'Pay_face_fail',
			component: () => import('./views/face_curriculum/pay_face_fail.vue')
		},
		{
			path: '/pay_face_result_h5',
			name: 'Pay_faceResultH5',
			component: () => import('./views/face_curriculum/pay_face_result_h5.vue')
		},
		{
			path: '/cashier',
			name: 'Cashier',
			component: () => import('./views/cashier/cashier.vue')
		},
{
			path: '/cashier_cs',
			name: 'CashierCs',
			component: () => import('./views/cashier/cashier_cs.vue')
		},
		{
			path: '/cashier_pay_success',
			name: 'CashierPaySuccess',
			component: () => import('./views/cashier/cashier_pay_success.vue')
		},
{
			path: '/cashier_pay_success_cs',
			name: 'CashierPaySuccessCs',
			component: () => import('./views/cashier/cashier_pay_success_cs.vue')
		},
		{
			path: '/change_name',
			name: 'ChangeName',
			component: () => import('./views/profile/change_name.vue')
		},
		{
			path: '/sale_performance',
			name: 'SalePerformance',
			component: () => import('./views/profile/sale_performance'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/group_list',
			name: 'GroupList',
			component: () => import('./views/group_curriculum/group_list'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/groupCurriculum_detail',
			name: 'GroupCurriculumDetail',
			component: () => import('./views/group_curriculum/groupCurriculum_detail.vue'),
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/group_pay_success',
			name: 'Group_Pay_success',
			component: () => import('./views/group_curriculum/group_pay_success.vue')
		},
		{
			path: '/group_pay_fail',
			name: 'Group_Pay_fail',
			component: () => import('./views/group_curriculum/group_pay_fail.vue')
		},
		{
			path: '/group_pay_result_h5',
			name: 'Group_PayResultH5',
			component: () => import('./views/group_curriculum/group_pay_result_h5.vue')
		},
		{
			path: '/coupon_list',
			name: 'CouponList',
			component: () => import('./views/profile/coupon_list.vue')
		},
		{
			path: '/qrcode',
			name: 'Qrcode',
			component: () => import('./views/download_app/qrcode.vue')
		},
	]
})


/**
 * 路由守卫设置
 */

const whiteList = ['/',
	'/login',
	'/login_password',
	'/login_set',
	'/login_agreement',
	'/course_detail',
	'/pack_detail',
	'/broadcast_open_course', //公开课
	'/popularize',
	'/popularizes'

] // no redirect whitelist

router.beforeEach(async (to, from, next) => {

	//let token = localStorage.getItem('token')
	 store.commit('userModule/SET_login_popup_show', false);  
	  
	  // 继续导航
	next()
	// if (token) {
	//   if(from.path=="/course_detail" && to.path == "/login_password"){
	//       next("/main/practise")
	//   }else{
	//     next()
	//   }
	// } else {
	//   if (whiteList.indexOf(to.path) !== -1) {
	//     next()
	//   } else {
	//     next(`/login?redirect=${to.path}`)
	//   }
	// }
})

router.afterEach(() => {
	// finish progress bar
})


export default router
